import { MantineThemeOverride } from '@mantine/core';

export type BlockquoteTheme = NonNullable<MantineThemeOverride['components']>['Blockquote'];

export const Blockquote: BlockquoteTheme = {
  // todo: define
};
